import { render, staticRenderFns } from "./FotosJCPOLI3.vue?vue&type=template&id=79294274&"
import script from "./FotosJCPOLI3.vue?vue&type=script&lang=ts&"
export * from "./FotosJCPOLI3.vue?vue&type=script&lang=ts&"
import style0 from "./FotosJCPOLI3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports